// extracted by mini-css-extract-plugin
export default {"l":"_4511f2211d"};